<template>
	<div class="loader-box" :class="{ inline: type == 'inline' }" v-if="show">
		<div class="loader">
			<div class="icon"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Loader",
	props: ["show", "type"],
	methods: {
		// fadeEffect = setInterval(() => {
		// // if we don't set opacity 1 in CSS, then
		// // it will be equaled to "" -- that's why
		// // we check it, and if so, set opacity to 1
		// if (!preloader.style.opacity) {
		// preloader.style.opacity = 1;
		// }
		// if (preloader.style.opacity > 0) {
		// preloader.style.opacity -= 0.1;
		// } else {
		// clearInterval(fadeEffect);
		// }
		// }, 100);
	}
}
</script>

<style scoped>
.loader-box {
	width: 100%;
	height: 100%;
	position: fixed;
	background-color: rgba(255, 255, 255, 0.8);
	top: 0px;
	left: 0px;
	z-index: 2500;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: all 0.5s ease-in-out;
}
.loader-box.inline {
	height: 50vh;
	position: relative;
	background-color: transparent;
}
.loader {
	margin: auto;
	width: 64px;
	height: 54px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #fff;
	box-shadow: 1px 1px 21px 16px rgba(255, 255, 255, 1);
	-webkit-box-shadow: 1px 1px 21px 16px rgba(255, 255, 255, 1);
	-moz-box-shadow: 1px 1px 21px 16px rgba(255, 255, 255, 1);
}
.icon {
	width: 100%;
	height: 100%;
	background: url(~@/assets/img/loader.gif);
	background-size: contain;
	background-position: center center;
	background-repeat: no-repeat;
}
.loader-box.inline .icon {
	width: 32px;
	height: 32px;
	background: url(~@/assets/img/loader.gif);
	background-size: cover;
	opacity: 0.7;
}
</style>
